import { useGetSvgIconFill } from "@intelligems/ig-theme/hooks/use-get-svg-icon-fill";
import { SvgIcon, SvgIconProps, useTheme } from "@mui/material";

export const OnboardingStepperHeaderIcon = (
  props: SvgIconProps & { active?: boolean; completed?: boolean }
) => {
  const theme = useTheme();
  const { active, completed, ...rest } = props;
  return (
    <SvgIcon {...rest}>
      <svg
        {...rest}
        viewBox="0 0 24 24"
        fill="none"
        stroke={
          active || completed
            ? theme.igIconColors.accent // this is an exception to the fill hook rule
            : theme.igIconColors.light
        }
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="12" cy="12" r="10"></circle>
        {active ? (
          <circle cx="12" cy="12" r="1"></circle>
        ) : completed ? (
          <path d="m9 12 2 2 4-4"></path>
        ) : null}
      </svg>
    </SvgIcon>
  );
};
